import {
  initialLandlineConsumptionState,
  LandlineConsumptionInterfaceState,
} from '../state/land-line-consumption.state';
import { ELandlineConsumptionActions, LandlineConsumptionActions } from '../actions/land-line-consumption.actions';

export function landlineConsumptionReducer(state: LandlineConsumptionInterfaceState = initialLandlineConsumptionState, action: LandlineConsumptionActions): LandlineConsumptionInterfaceState {
  switch (action.type) {
    case ELandlineConsumptionActions.GetLandlineConsumptionSuccess: {
      return { ...state, landlineConsumption: action.payload };
    }

    default:
      return state;
  }
}
